import { Star } from "lucide-react";

// Read-only or interactive 1-5 star rating
export function Stars({ value = 0, onChange, size = "sm", testid = "stars" }) {
  const dim = size === "sm" ? "h-3.5 w-3.5" : "h-6 w-6";
  return (
    <span className="inline-flex items-center gap-0.5" data-testid={testid} aria-label={`${value}/5`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" disabled={!onChange} onClick={() => onChange?.(n === value ? null : n)}
          data-testid={`${testid}-${n}`}
          className={`${onChange ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"} disabled:cursor-default`}>
          <Star className={`${dim} ${n <= value ? "fill-chenia-terracotta text-chenia-terracotta" : "text-chenia-sand"}`} />
        </button>
      ))}
    </span>
  );
}
